import { FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import DefaultButton from "../../../../../components/Buttons/Default";
import { post } from "../../../../../utils/helpers/api";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function CreateCategoryModal({ isOpen, toggle, refreshCategories, editData = null }) {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const saveCategory = async () => {
    setLoading(true);
    let query = editData ? `/inventory/categories/update/${editData.id}` : `/inventory/categories/store`;
    const data = await post(query, { name });
    if(data?.success) {
      refreshCategories();
      toggle();
    }
    setLoading(false);
  }

  useEffect(() => {
    if(editData) {
      setName(editData.name);
    } else {
      setName("");
    }
  }, [editData, isOpen]);

  return(
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>{editData ? t('inventory.editCategory') : t('inventory.createCategory')}</ModalHeader>

      <ModalBody>
        <FormGroup>
          <Label>{t('common.name')}: </Label>
          <Input
            type="text"
            placeholder={t('inventory.categoryNamePlaceholder')}
            value={name}
            onChange={(e) => setName(e.target.value)} 
          />
        </FormGroup>

        <DefaultButton 
          color="primary" 
          block 
          onClick={saveCategory}
          loading={loading}
          disabled={!name.trim() || loading}
        >
          {t('common.save')}
        </DefaultButton>
      </ModalBody>
    </Modal>
  );
}

export default CreateCategoryModal;